export function formatList(
  items: readonly string[],
  locale: string,
  opts: Intl.ListFormatOptions = {},
): string {
  return new Intl.ListFormat(locale, { style: 'long', type: 'conjunction', ...opts }).format(items);
}
